export const notProductCategoryName = "כללי"
